<template>
  <div class="main">
    <!-- 红字发票确认信息录入 -->
    <div class="header-block">
      <div class="header-banner"></div>
      <div class="header-arrow">
        <el-icon @click="emits('changePage', 'redInvoice_home')"><Back /></el-icon>
        <el-breadcrumb separator-icon="arrowRight">
          <el-breadcrumb-item>红字发票业务</el-breadcrumb-item>
          <el-breadcrumb-item style="font-weight: 700">红字发票确认信息录入</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class="operate-main">
      <div class="common-box">
        <div class="steps-box">
          <el-steps :space="200" :active="active" finish-status="success" style="min-width: 600px">
            <el-step title="选择票据" />
            <el-step title="信息确认" />
            <el-step title="提交成功" />
          </el-steps>
        </div>
        <!-- 第一步 -->
        <div class="step-first" v-if="active === 0">
          <el-form ref="queryRef" :model="queryParams" :inline="true" label-width="140px" class="search-box">
            <el-row>
              <el-col :span="8">
                <el-form-item label="购/销方选择" prop="is_my">
                  <el-select v-model="queryParams.is_my">
                    <el-option label="我是销售方" value="1" />
                    <el-option label="我是购买方" value="0" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="对方纳税人识别号" prop="buyer.taxRegistrationNo">
                  <el-input v-model.trim="queryParams.buyer.taxRegistrationNo" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="对方纳税人名称" prop="buyer.name">
                  <el-input v-model.trim="queryParams.buyer.name" placeholder="请输入" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="8">
                <el-form-item label="开票日期起" prop="beginTime">
                  <el-input v-model="queryParams.beginTime" placeholder="yyyy/mm/日" :readonly="true" suffix-icon="Calendar" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开票日期止" prop="endTime">
                  <el-input v-model="queryParams.endTime" placeholder="yyyy/mm/日" :readonly="true" suffix-icon="Calendar" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="数电票号码" prop="number">
                  <el-input v-model.trim="queryParams.number" placeholder="请输入" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="发票代码" prop="fpdm">
                  <el-input v-model.trim="queryParams.fpdm" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发票号码" prop="fphm">
                  <el-input v-model.trim="queryParams.fphm" placeholder="请输入" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <div style="width: 100%; margin-top: 20px; display: flex; justify-content: end">
            <el-button type="default" @click="resetQuery">重置</el-button>
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </div>

          <div class="search_data">
            <div style="padding: 20px" v-if="blues.length === 0">
              <img src="https://static.rhkj.com/renhe_fe/other/redInvoice/kong.png" style="display: block; margin: 20px auto" />
              <p class="font14 cor999 text-center" style="font-size: 14px; color: #999; text-align: center">暂无数据</p>
            </div>
            <template v-else>
              <div class="list-box">
                <ul>
                  <li class="box-line" v-for="item in blues" :key="item.id">
                    <div class="left-text">
                      <p>
                        <span> {{ `${item.number}`.length > 10 ? '数电票' : '发票' }}号码:{{ item.number }}</span>
                        <span style="margin-left: 20px">价税合计:{{ Number(item.totalAddedTaxAmount || 0).toFixed(2) }}元</span>
                      </p>
                      <p>购买方:{{ item.buyer?.name }}</p>
                      <p class="font12 cor999 mt10">开票日期:{{ item.hzMakeDate }}</p>
                    </div>
                    <div class="right-btns">
                      <el-button type="primary" link @click="yulan(item)">预览票据</el-button>
                      <el-button type="primary" @click="choose(item)">选择</el-button>
                    </div>
                  </li>
                </ul>
              </div>
            </template>
          </div>
          <!-- 预览发票 -->
          <invoce-dialog v-model="visible" :row="currentRow" />
        </div>

        <!-- 步骤二 -->
        <div class="step-second" v-else-if="active === 1">
          <p style="font-size: 14px; font-weight: 600; color: #333; margin-top: 15px">已选发票</p>
          <div class="box-line">
            <p style="font-size: 14px; font-weight: 600; color: #333">
              票面金额：{{ Number(detail.totalAddedTaxAmount || 0).toFixed(2) }} <span style="margin: 0 10px; color: #ddd">|</span> 数电票号码
              {{ detail.number }}
            </p>

            <el-row style="margin-top: 10px">
              <el-col :span="5">
                <p style="font-size: 14px; color: #666; margin-top: 10px">(销售方)纳税人名称</p>
                <p style="font-size: 14px; color: #666; margin-top: 10px">
                  {{ detail.seller?.name }}
                </p>
                <p style="font-size: 14px; color: #666; margin-top: 20px">开票日期</p>
                <p style="font-size: 14px; color: #666; margin-top: 10px">
                  {{ detail.hzMakeDate }}
                </p>
              </el-col>
              <el-col :span="7">
                <p style="font-size: 14px; color: #666; margin-top: 10px">(销售方)统一社会信用代码/纳税人识别号</p>
                <p style="font-size: 14px; color: #666; margin-top: 10px">
                  {{ detail.seller?.taxRegistrationNo }}
                </p>
                <p style="font-size: 14px; color: #666; margin-top: 20px">增值税用途状态</p>
                <p style="font-size: 14px; color: #666; margin-top: 10px">未勾选</p>
              </el-col>
              <el-col :span="5">
                <p style="font-size: 14px; color: #666; margin-top: 10px">(购买方)纳税人名称</p>
                <p style="font-size: 14px; color: #666; margin-top: 10px">
                  {{ detail.buyer?.name }}
                </p>
                <p style="font-size: 14px; color: #666; margin-top: 20px">消费税用途状态</p>
                <p style="font-size: 14px; color: #666; margin-top: 10px">未勾选</p>
              </el-col>
              <el-col :span="7">
                <p style="font-size: 14px; color: #666; margin-top: 10px">(购买方)统一社会信用代码/纳税人识别号</p>
                <p style="font-size: 14px; color: #666; margin-top: 10px">
                  {{ detail.buyer?.taxRegistrationNo }}
                </p>
                <p style="font-size: 14px; color: #666; margin-top: 20px">入账状态</p>
                <p style="font-size: 14px; color: #666; margin-top: 10px">未入账</p>
              </el-col>
            </el-row>
          </div>

          <div style="margin-top: 20px">
            <p class="font14 cor333" style="font-size: 14px; color: #333">开具红字发票原因</p>
            <el-space :size="20">

              <el-form ref="formRef" :model="detail"
                       :rules="{'checker': [{ required: true, message: '请选择', trigger: 'blur' }]}">
                <el-form-item
                    prop="checker"
                    style="margin-bottom: 5px;">
                  <el-select
                      v-model="detail.checker" style="width: 300px; margin-top: 10px">
                    <el-option label="开票有误" value="1" />
                    <el-option label="服务中止" value="2" />
                    <el-option label="销货退回" value="3" />
                    <el-option label="销售折让" value="4" />
                  </el-select>
                </el-form-item>
              </el-form>

              <el-radio-group v-model="detail.addedTax">
                <el-radio label="不含税" :value="false" />
                <el-radio label="含税" :value="true" />
              </el-radio-group>
            </el-space>
          </div>

          <div style="margin-top: 15px">
            <el-button type="primary" @click="addTable">新增</el-button>
          </div>

          <div class="table-wrap">
            <el-table
              :data="detail.items"
              :border="true"
              :row-class-name="
                ({ row, rowIndex }) => {
                  row.rowIndex = rowIndex;
                  return '';
                }
              "
            >
              <el-table-column label="项目名称" prop="name">
                <template #default="{ row }">
                  <div>
                    <el-input v-model.trim="row.name" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="规格型号" prop="specification" align="center">
                <template #default="{ row }">
                  <div>
                    <el-input v-model.trim="row.specification" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="单位" prop="unit" align="center">
                <template #default="{ row }">
                  <div>
                    <el-input v-model.trim="row.unit" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="数量" prop="count" align="center">
                <template #default="{ row, column }">
                  <div>
                    <el-input v-model.trim="row.count" @blur="() => blur(row, column)" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="`单价${detail.addedTax ? '（含税）' : '（不含税）'}`" prop="price" align="center">
                <template #default="{ row, column }">
                  <div>
                    <el-input v-model.trim="row.price" @blur="() => blur(row.column)" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="`金额${detail.addedTax ? '（含税）' : '（不含税）'}`" prop="amount" align="center">
                <template #default="{ row, column }">
                  <div style="--el-text-color-regular: #fb5133">
                    <el-input v-model.trim="row.amount" @blur="() => blur(row, column)" />
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="税率/征收率" prop="rate" align="center">
                <template #default="{ row }">
                  <el-select v-model="row.rate" :empty-values="[null, undefined]" @change="sumTable">
                    <el-option label="请选择税率" value="" />
                    <el-option label="0%" :value="0" />
                    <el-option label="1%" :value="0.01" />
                    <el-option label="3%" :value="0.03" />
                    <el-option label="5%" :value="0.05" />
                    <el-option label="6%" :value="0.06" />
                    <el-option label="9%" :value="0.09" />
                    <el-option label="13%" :value="0.13" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="税额" prop="taxAmount" align="center">
                <template #default="{ row }">
                  <span style="color: #fb5133">{{ row.taxAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="60">
                <template #default="{ row }">
                  <el-button type="primary" link @click="deleteRow(row)">删除</el-button>
                </template>
              </el-table-column>
              <template #append>
                <div
                  style="
                    box-sizing: border-box;
                    width: 100%;
                    height: 50px;
                    padding: 0 8px;
                    line-height: 50px;
                    border-bottom: 1px solid #ddd;
                    display: flex;
                  "
                >
                  <p style="width: 20%">合计</p>
                  <p style="width: 50%; text-align: end">￥{{ detail.totalAmount }}</p>
                  <p style="width: 20%; text-align: end">￥{{ detail.totalTaxAmount }}</p>
                </div>
                <div
                  style="
                    box-sizing: border-box;
                    width: 100%;
                    height: 50px;
                    padding: 0 8px;
                    line-height: 50px;
                    border-bottom: 1px solid #ddd;
                    display: flex;
                  "
                >
                  <p style="width: 70%; text-align: end; font-weight: 700">价税合计(大写): ⊗{{ detail.payee }}</p>
                  <p style="width: 20%; text-align: end; font-weight: 700">价税合计(小写)：{{ detail.totalAddedTaxAmount }}</p>
                </div>
              </template>
            </el-table>
          </div>

          <div style="margin-top: 30px; display: flex; align-items: center; justify-content: center">
            <el-button type="default" @click="goFirstStep">上一步</el-button>
            <el-button type="primary" @click="submitSecond">提交</el-button>
          </div>
        </div>

        <!-- 步骤三 -->
        <div class="step-last" v-else>
          <div style="text-align: center">
            <img src="https://static.rhkj.com/renhe_fe/other/blueInvoice/dui.png" alt="#" style="width: 45px" />
            <p style="text-align: center; font-size: 16; color: #333; font-weight: 600; line-height: 30px">提交成功</p>
            <p style="font-size: 12px; color: #999">本次红字发票信息确认单无需对方确认可直接开具发票</p>
          </div>
          <div style="margin-top: 10px; text-align: center">
            <el-button type="primary" link @click="emits('changePage', 'redInvoice_queren')">去开红字发票</el-button>
          </div>
          <div class="step-last-info">
            <p style="line-height: 24px; font-weight: 600; font-size: 14px">确认单简要信息</p>
            <el-row jutify="space-between">
              <el-col :span="12">
                <p style="line-height: 24px; font-size: 14px">
                  <span style="color: #666"> 开单时间:</span><span style="color: #333">{{ detail.createTime }}</span>
                </p>
              </el-col>
              <el-col :span="12">
                <p style="line-height: 24px; font-size: 14px">
                  <span style="color: #666"> 确认方名称:</span> <span style="color: #333">{{ detail.buyer?.name }}</span>
                </p>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <p style="line-height: 24px; font-size: 14px">
                  <span style="color: #666"> 价税合计(元):</span
                  ><span style="color: #333">¥{{ Number(detail.totalAddedTaxAmount || 0)?.toFixed(2) }}</span>
                </p>
              </el-col>
              <el-col :span="12">
                <p style="line-height: 24px; font-size: 14px">
                  <span style="color: #666"> 红字发票信息确认单编号:</span><span style="color: #333">{{ detail.number }}</span>
                </p>
              </el-col>
            </el-row>
          </div>

          <div style="margin-top: 30px; display: flex; align-items: center; justify-content: center">
            <el-button type="default" @click="closeApply">关闭申请</el-button>
            <el-button type="default" @click="open = true"> 查看确认单详情</el-button>
            <el-button type="primary" @click="closeApply">继续新增确认单</el-button>
          </div>
        </div>
      </div>
      <hz-basic-dialog v-model="open" :row="detail" />
    </div>
  </div>
</template>

<script setup name="RedInvoice/enter">
import invoceDialog from '../cmp/invoceDialog.vue';
import hzBasicDialog from '../cmp/hzBasicDialog.vue';
import { numberToChinese, generateID } from '@/utils/ruoyi';
import dayjs from 'dayjs';
import useInvoiceStore from '@/store/modules/invoice';
import {ElMessage} from "element-plus";

const useInvoice = useInvoiceStore();

const emits = defineEmits(['changePage']);

const active = ref(0);
const queryParams = reactive({
  is_my: '1',
  buyer: {
    name: '',
    taxRegistrationNo: '',
  },
  number: '',
  beginTime: '',
  endTime: '',
  fpdm: '',
  fphm: '',
});
const queryRef = ref();
const blues = ref([]);
const currentRow = ref({});
const visible = ref(false);

//选择的红字数据
const detail = ref({});

//点击查询
async function handleQuery() {
  let params = Object.assign({}, toRaw(queryParams));
  Reflect.deleteProperty(params, 'is_my');
  Reflect.deleteProperty(params, 'fpdm');
  Reflect.deleteProperty(params, 'fphm');
  const invoiceList = useInvoice.blueInvoiceList;
  blues.value = [];
  // invoiceList.forEach((item) => {
  //   blues.value.push(item);
  // });
  const { redInvoiceList } = useInvoice;
  const redItemList = redInvoiceList.filter((item) => item.isQueren == 4);
  for (let item of redItemList) {
    const redItemFu = redInvoiceList.some((el) => -el.totalAddedTaxAmount == item?.totalAddedTaxAmount);
    if (!redItemFu) {
      blues.value.push(item);
    }
  }
}

//重置
function resetQuery() {
  queryRef.value && queryRef.value.resetFields();
  queryParams.is_my = '1';
}

//警告功能
function warn(content) {
  let msg = content ? content : '本系统为教学系统，暂不支持此功能';
  ElMessageBox.confirm(msg, '信息', {
    showCancelButton: false,
    customStyle: {
      '--el-messagebox-width': '300px',
    },
  }).catch(() => {});
}

//点击预览
function yulan(data) {
  currentRow.value = Object.assign({}, toRaw(data));
  visible.value = true;
}

//点击选择
function choose(data) {
  active.value = 1;
  detail.value = Object.assign({}, toRaw(data), {checker: undefined});
  let items = data.items.map((item) => {
    let count = parseInt(item.count),amount = parseFloat(item.amount),taxAmount = parseFloat(item.taxAmount)
    return {
      ...item,
      count: count <= 0 ? count: (count * -1),
      amount: amount <= 0 ? amount: (amount * -1),
      taxAmount: taxAmount <= 0 ? taxAmount: (taxAmount * -1),
    };
  });
  detail.value.items = [...items];
}

watch(
  () => detail.value.items,
  (list) => {
    if (active.value == 1) {
      const totalAmount = list.reduce((sum, pre) => {
        return (sum += Number(pre.amount || 0));
      }, 0);

      const totalTaxAmount = list.reduce((sum, pre) => {
        return (sum += Number(pre.taxAmount || 0));
      }, 0);
      detail.value.totalAmount = Number(totalAmount).toFixed(2);
      detail.value.totalTaxAmount = Number(totalTaxAmount).toFixed(2);
      if (detail.value.addedTax) {
        detail.value.totalAddedTaxAmount = detail.value.totalAmount;
      } else {
        detail.value.totalAddedTaxAmount = Number(totalAmount + totalTaxAmount || 0).toFixed(2);
      }
      detail.value.payee = numberToChinese(detail.value.totalAddedTaxAmount);
    }
  },
  { deep: true }
);

watch(
  () => detail.value.addedTax,
  (val) => {
    if (active.value == 1) {
      sumTable();
    }
  }
);

function sumTable() {
  detail.value.items.forEach((item) => {
    if (detail.value.addedTax) {
      const realAmount = item.amount / (1 + Number(item.rate));
      item.taxAmount = Number(item.amount - realAmount).toFixed(2);
    } else {
      item.taxAmount = Number(item.amount * item.rate || 0).toFixed(2);
    }
  });
}

function blur(row, column) {
  if (['count', 'price'].includes(column?.property)) {
    row.count ||= -1;
    row.price ||= row.amount;
    row.amount = Number(row.count * row.price || 0).toFixed(2);
  }
  sumTable();
}
//添加表格行
function addTable() {
  detail.value.items.push({
    amount: '',
    count: '',
    discountRow: null,
    name: '',
    price: null,
    rate: '',
    specification: '',
    taxAmount: null,
    unit: '',
  });
}

//删除表格行
function deleteRow(row) {
  detail.value.items.splice(row.rowIndex, 1);
}

//返回第一步
function goFirstStep() {
  active.value = 0;
  detail.value = {};
}

const formRef = ref()

//点击提交
async function submitSecond() {
  formRef.value.validate((valid) => {
    if (valid) {
      detail.value.createTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
      detail.value.applyType = '销售方申请';
      detail.value.code = detail.value.number;
      detail.value.number = '25000016848964748531';
      useInvoice.addRedInvoice(detail.value);
      active.value = 2;
    } else {
      ElMessage.error('请检查标红项')
    }
  })
}

const open = ref(false);
//关闭申请
function closeApply() {
  active.value = 0;
  blues.value = [];
}
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  font-size: 16px;
  background-color: #f6f7fb;
  display: flex;
  flex-direction: column;
  .header-block {
    flex: none;
    width: 100%;
    .header-banner {
      width: 100%;
      height: 0.64rem;
      background: #fff url('https://static.rhkj.com/renhe_fe/other/stateTax/head_log.png') no-repeat top / 100% 100%;
    }
    .header-arrow {
      width: inherit;
      height: 0.6rem;
      padding-left: 0.2rem;
      font-size: 0.18rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      column-gap: 0.1rem;
      > .bread {
        margin-inline-start: 0.1rem;
        font-weight: 600;
        color: #333;
      }
    }
  }

  .operate-main {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px;
    overflow-y: scroll;
    .common-box {
      box-sizing: border-box;
      width: 100%;
      padding: 30px 0 20px;
      border-radius: 3px;
      background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
      .steps-box {
        width: 100%;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .step-first {
        box-sizing: border-box;
        padding: 20px;
        :deep(.search-box) {
          margin-top: 20px;
          .el-form-item {
            width: 100%;
            .el-form-item__label {
              white-space: nowrap;
            }
          }
        }

        .search_data {
          .list-box {
            > ul {
              display: flex;
              flex-direction: column;
              .box-line {
                box-sizing: border-box;
                width: 100%;
                padding: 20px;
                margin-top: 20px;
                border-radius: 4px;
                border: 1px solid #eee;
                display: flex;
                align-items: center;
                .left-text {
                  flex: 1;
                  > p {
                    line-height: 24px;
                    font-weight: 600;
                    font-size: 14px;
                    color: #333;
                    &:last-child {
                      font-size: 12px;
                      font-weight: 400;
                    }
                    > span {
                      line-height: 24px;
                      font-weight: 600;
                      font-size: 14px;
                      color: #333;
                    }
                  }
                }
                .right-btns {
                  flex: none;
                  width: 300px;
                  text-align: end;
                }
              }
            }
          }
        }
      }

      .step-second {
        box-sizing: border-box;
        width: 100%;
        padding: 20px;

        .box-line {
          box-sizing: border-box;
          width: 100%;
          padding: 20px;
          margin-top: 20px;
          border: 1px solid #eee;
          border-radius: 4px;
        }
        .table-wrap {
          width: 100%;
          min-height: 120px;
          height: calc(86vh - 530px);
          margin-top: 20px;
          overflow-x: auto;
        }
      }

      .step-last {
        box-sizing: border-box;
        width: 100%;
        padding: 20px;
        .step-last-info {
          box-sizing: border-box;
          width: 800px;
          padding: 20px;
          margin: 20px auto;
          background-color: #f9fafe;
        }
      }
    }
  }
}
</style>
